import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {ConsoleContextService} from "@security/console-context.service";
import {ConsoleAuthenticationService} from "@security/console-authentication.service";


@Injectable({
  providedIn: 'root'
})
export class PathContextGuardService {

  constructor(private context: ConsoleContextService,
              private auth: ConsoleAuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let clientId = route.paramMap.get('clientId')?.toLowerCase();
    if (clientId != this.context.getCurrentLandlordCode()?.toLowerCase() && clientId != this.context.getCurrentLandlordId()?.toLowerCase()) {
      this.auth.logout(true);
      return false;
    }
    return true;
  }
}

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const service = inject(PathContextGuardService);
  return service.canActivate(route, state);
}
